<template>
  <v-card tile>
    <BaseToolbar
      :title="$t('general.assign')"
      type-title="icon"
      icon="business"
      :button-save="differentOrganizations.length > 0 ? true : false"
      @save="save"
      @close="closeAssignDrawer"
    />
    <v-card-text class="overflow-y-auto" style="height: calc(100vh - 64px)">
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="role_id"
              v-validate="'required'"
              :label="$t('profile.profile.role')"
              :items="roles"
              dense
              item-text="name"
              item-value="id"
              :data-vv-name="$t('profile.profile.role')"
              :error-messages="errors.collect($t('profile.profile.role'))"
              outlined
              hide-details
            />
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="differentOrganizations"
                class="elevation-0"
                v-model="selected"
                show-select
              >
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'

export default {
  name: 'AssignOrganization',
  components: { BaseToolbar },
  async created () {
    this.getRole()
  },
  data () {
    return {
      selected: [],
      headers: [
        {
          text: this.$t('organization.table.org_name'),
          value: 'name',
          class: 'text-no-wrap blue--text text--darken-4',
          width: ''
        }
      ],
      roles: [],
      role_id: null
    }
  },
  computed: {
    ...mapState({
      organizations: ({ organization: { organizations } }) => organizations,
      user: ({ user: { user } }) => user,
      differentOrganizations: ({ user: { differentOrganizations } }) => differentOrganizations
    })
  },
  methods: {
    ...mapActions({
      getAll: 'organization/getAll',
      getAllUsers: 'user/getAll',
      assignOrganization: 'user/assignOrganization',
      getRoles: 'roles/getRoles'
    }),
    ...mapMutations({
      AssignOrgDrawer: 'user/AssignOrgDrawer'
    }),
    getRole () {
      this.getRoles({
        limit: 'all',
        sort: 'id:asc',
        filter: { is_admin: false }
      }).then(res => {
        this.roles = res
      })
    },
    closeAssignDrawer () {
      this.organizationsLocal = []
      this.selected = []
      this.AssignOrgDrawer(false)
    },
    async save () {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        if (this.selected.length > 0) {
          let organizations_ids = this.selected.map(el => el.id)
          this.assignOrganization({
            organizations_ids,
            user_id: this.user.id,
            role_id: this.role_id
          })
            .then(
              res => {
                this.$noty.success(this.$t('users.messages.assign_success'))
                this.getAllUsers()
                this.closeAssignDrawer()
              },
              err => {
                this.$noty.error(this.$t('users.messages.assign_error'))
                console.log(err)
              }
            )
        } else {
          this.$noty.error(this.$t('users.messages.assign_error_clean'))
        }
      }
    },
    generateRandomColor () {
      var randomColor = '#000000'.replace(/0/g, function () { return (~~(Math.random() * 16)).toString(16) })
      return randomColor
    }
  }
}
</script>

<style>

</style>
